<div [class]="badgeClass" [innerHtml]="text"></div>